__turbopack_context__.v({
  "content": "IOmaHW_content",
  "message": "IOmaHW_message",
  "wrapper": "IOmaHW_wrapper",
});
